export default __webpack_public_path__ + "static/media/product-item-01.a962dff1.jpg";